import { NavItem } from '@billy/design-system'
import { useMemo } from 'react'

import { useContactPersons } from '../../../../../../../../../../../../../hooks/useContactPersons'
import { useInvoiceEditorForm } from '../../../../../../../../../contexts/invoiceEditorFormContext'

export const useContactPersonItems = () => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const receiver = invoiceEditorForm.watch('receiver')

  const { contactPersons, isLoading } = useContactPersons({ contactId: receiver?.id })

  const contactPersonItems: NavItem[] = useMemo(() => {
    const contactPersonsWithEmail = contactPersons.filter((contactPerson) => !!contactPerson.email)

    return contactPersonsWithEmail.map((contactPerson) => ({
      id: contactPerson?.id || '',
      children: contactPerson.name,
      value: contactPerson.email || '',
    }))
  }, [contactPersons])

  return { contactPersonItems, isLoading }
}
